export { DMS_MODULE } from '../constants';
export const NAME = 'PlanovanaPujckaVozidla';
export const CRUMB_LABEL_KEY = 'grdPlanpujcpa';
